import { Component, ChangeDetectionStrategy, Inject } from '@angular/core';
import { MAT_LEGACY_DIALOG_DATA } from '@angular/material/legacy-dialog';
import { DialogService } from '@mode/shared/ui';

interface TextSettings {
  showAll: boolean;
  showFirst: boolean;
  showLast: boolean;
  showMax: boolean;
  showMin: boolean;
  useLabelThinning: boolean;
}

export interface EditTextModalData {
  showAll: boolean;
  showFirst: boolean;
  showLast: boolean;
  showMax: boolean;
  showMin: boolean;
  useLabelThinning: boolean;
  fieldName: string;
  series: string | undefined;
  onApply: (
    showAll: boolean,
    showFirst: boolean,
    showLast: boolean,
    showMax: boolean,
    showMin: boolean,
    useLabelThinning: boolean,
    series: string | undefined
  ) => void;
}

export enum MarkOptions {
  All = 'All',
  First = 'First',
  Last = 'Last',
  Min = 'Min',
  Max = 'Max',
}
@Component({
  selector: 'mode-edit-text-modal',
  templateUrl: './edit-text-modal.component.html',
  styleUrls: ['./edit-text-modal.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class EditTextModalComponent {
  readonly MarkOptions = MarkOptions;

  private initialSettings: TextSettings;
  currentSettings: TextSettings;

  fieldName = '';
  series: string | undefined;

  onApply: (
    showAll: boolean,
    showFirst: boolean,
    showLast: boolean,
    showMax: boolean,
    showMin: boolean,
    useLabelThinning: boolean,
    series: string | undefined
  ) => void;

  constructor(
    @Inject(MAT_LEGACY_DIALOG_DATA) data: EditTextModalData,
    private dialogService: DialogService
  ) {
    this.initialSettings = {
      showAll: data.showAll,
      showFirst: data.showFirst,
      showLast: data.showLast,
      showMax: data.showMax,
      showMin: data.showMin,
      useLabelThinning: data.useLabelThinning,
    };
    this.currentSettings = { ...this.initialSettings };
    this.fieldName = data.fieldName;
    this.series = data.series;

    this.onApply = data.onApply;
  }

  get isShowAll() {
    return this.currentSettings.showAll;
  }

  get isShowFirst() {
    return this.currentSettings.showFirst;
  }

  get isShowLast() {
    return this.currentSettings.showLast;
  }

  get isShowMax() {
    return this.currentSettings.showMax;
  }

  get isShowMin() {
    return this.currentSettings.showMin;
  }

  get useLabelThinning() {
    return this.currentSettings.useLabelThinning;
  }

  onCheckBoxChange(id: string, $event: any) {
    const checked = $event.target.checked;
    switch (id) {
      case MarkOptions.All:
        this.currentSettings.showAll = checked;
        break;
      case MarkOptions.First:
        this.currentSettings.showFirst = checked;
        break;
      case MarkOptions.Last:
        this.currentSettings.showLast = checked;
        break;
      case MarkOptions.Max:
        this.currentSettings.showMax = checked;
        break;
      case MarkOptions.Min:
        this.currentSettings.showMin = checked;
        break;
    }
    this.validateSettings();
  }

  setUseLabelThinning(enabled: boolean) {
    this.currentSettings.useLabelThinning = enabled;
  }

  validateSettings() {
    this.currentSettings.showFirst = !this.currentSettings.showAll && this.currentSettings.showFirst;
    this.currentSettings.showLast = !this.currentSettings.showAll && this.currentSettings.showLast;
    this.currentSettings.showMax = !this.currentSettings.showAll && this.currentSettings.showMax;
    this.currentSettings.showMin = !this.currentSettings.showAll && this.currentSettings.showMin;
  }

  reset() {
    this.currentSettings = { ...this.initialSettings };
  }

  updateChart(closeModal: boolean) {
    this.onApply(
      this.currentSettings.showAll,
      this.currentSettings.showFirst,
      this.currentSettings.showLast,
      this.currentSettings.showMax,
      this.currentSettings.showMin,
      this.currentSettings.useLabelThinning,
      this.series
    );
    this.initialSettings = { ...this.currentSettings };
    closeModal && this.dialogService.closeAll();
  }
}
